import { store } from '@/decorators/store';
import { Generations } from '@/entities/Generations';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';

@store({ id: 'Generations' })
export class GenerationsStore extends AbstractEntityStore<Generations> {
  protected entityIdKey = 'id';
  protected entityLabelKey = 'value';
  protected entityValueKey = 'value';
}
